import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import {
  // ClockCardIcon,
  DownloadIcon
  // LocationCardIcon,
  // ReviewCardIcon
} from "../../Assets/assets";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import Button from "../../Components/Button/Button";
// import { GraphCard, InfoCard, LegendCard } from "../../Components/Cards/Cards";
import DateRange from "../../Components/Filters/DateRange";
import MultipleSelect from "../../Components/Filters/MultipleSelect";
import SingleSelect from "../../Components/Filters/SingleSelect";
// import { DoughnutChart } from "../../Components/Graphs/DoughnutChart";
// import LineChart from "../../Components/Graphs/LineChart";
import ProcedureHistoryPreview from "../../Components/Previews/ProcedureHistoryPreview";
// import SearchBox from "../../Components/SearchBox/SearchBox";
import Table from "../../Components/Table/Table";
import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import {
  setSelectedTableData,
  setTableFilter,
  setTableSearchKey,
  setTableSort
} from "../../Redux/table/action";
import { isValidObject } from "../../Services/validators";
import {
  FilterSeparator,
  isFilterApplied
} from "../../Utils/Constants/Constants";
import {
  convertProcedureHistoryToTableData,
  defaultProcedureHistoryFilter,
  procedureHistoryFilterData,
  procedureHistoryTableField,
  procedureHistoryTableHeadings
} from "../../Utils/Constants/ProcedureHistory";

function ProcedureHistory(props) {
  const [selectedFilters, setSelectedFilters] = useState(
    defaultProcedureHistoryFilter
  );
  const [collapse, setCollapse] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    props.table.procedureHistory.pageNumber
  );
  const tableContainerRef = useRef(null);
  const filterContainerRef = useRef(null);
  const { height } = useResizeObserver(filterContainerRef);
  const [isResetSingleKey, setIsResetSingleKey] = useState(false);

  useEffect(() => {
    if (!isResetSingleKey) {
      setSelectedFilters(props.table.procedureHistory.filter);
    }
  }, [props.table.procedureHistory.filter, isResetSingleKey]);

  useEffect(() => {
    if (props.table.procedureHistory.pageNumber) {
      setCurrentPage(props.table.procedureHistory.pageNumber);
    }
  }, [props.table.procedureHistory.pageNumber]);

  const handleApplyClick = () => {
    props.setTableFilter("PROCEDURES_HISTORY", selectedFilters);
  };

  const handleResetClick = (key) => {
    setIsResetSingleKey(true);
    setSelectedFilters({
      ...selectedFilters,
      [key]: defaultProcedureHistoryFilter[key]
    });
    props.setTableFilter("PROCEDURES_HISTORY", {
      ...props.table.procedureHistory.filter,
      [key]: defaultProcedureHistoryFilter[key]
    });
  };

  const handleClearClick = () => {
    props.setTableFilter("PROCEDURES_HISTORY", defaultProcedureHistoryFilter);
    props.setTableSearchKey("PROCEDURES_HISTORY", "");
    setSelectedFilters(defaultProcedureHistoryFilter);
  };

  const handleDisableFilter = () => {
    return window.location.pathname.split("/")[3] ? true : false;
  };

  return (
    <>
      <Routes>
        <Route
          path="/:procedureHistoryId"
          element={
            <ProcedureHistoryPreview
              navigate={props.navigate}
              data={props.table.procedureHistory.selectedProcedureHistory}
              loading={props.procedureHistory.loading}
              assetsLoading={props.procedureHistory.assetsLoading}
            />
          }
        />
      </Routes>
      <div
        className="inherit-parent-height inherit-parent-width position-relative overflow-hidden"
        ref={tableContainerRef}
      >
        <div className="inherit-parent-width">
          <div className="display-flex flex-justify-content-space-between flex-align-items-center">
            <BreadCrumbs />
            <div className="display-flex">
              <div>
                <Button
                  variant="transparent"
                  text="Download summary"
                  boxShadow={false}
                  icon={
                    props.procedureHistoryLoading.export ? (
                      <div
                        className="qr-loader"
                        style={{ height: "16px", width: "16px" }}
                      />
                    ) : (
                      <DownloadIcon color="var(--tertiaryColor6)" />
                    )
                  }
                  onClick={() => {
                    if (!props.procedureHistoryLoading.export) {
                      props.getHistorySummary();
                    }
                  }}
                  className="width-fit-content padding-left-large padding-right-large"
                />
              </div>
            </div>
          </div>
          <div
            ref={filterContainerRef}
            className="padding-top-larger display-flex flex-justify-content-space-between"
          >
            <div
              style={{ width: "90%", flexWrap: "wrap", gap: "8px" }}
              className="display-flex flex-align-items-center"
            >
              {/* <div style={{ width: "200px" }}>
                  <SearchBox
                    title="SEARCH PROC. HISTORY"
                    placeHolder="SEARCH HISTORY"
                    value={props.table.procedureHistory.searchKey}
                    onChange={(event) => {
                      props.setTableSearchKey(
                        "PROCEDURE_HISTORY",
                        event.target.value
                      );
                    }}
                    showCloseIcon={
                      props.table.procedureHistory.searchKey ? true : false
                    }
                    closeOnClick={() => {
                      if (props.table.procedureHistory.searchKey.length > 0) {
                        props.setTableSearchKey("PROCEDURE_HISTORY", "");
                      }
                    }}
                  />
                </div>

                <FilterSeparator /> */}
              <div className="display-flex flex-align-items-center position-relative">
                <DateRange
                  disabled={handleDisableFilter()}
                  loading={props.procedures.loading}
                  data-cy="DATE-RANGE"
                  data={procedureHistoryFilterData()[1]}
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  multiple={true}
                  isFilterApplied={
                    props.table.procedureHistory.filter?.dateRange?.from &&
                    props.table.procedureHistory.filter?.dateRange?.to &&
                    props.table.procedureHistory.filter?.dateRange?.from !==
                      new Date().toISOString().split("T")[0]
                  }
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.procedureHistory.filter}
                  selected={selectedFilters["dateRange"]}
                />

                <FilterSeparator />
                  <MultipleSelect
                    loading={props.procedures.loading}
                    data-cy="PCT-NO-MULTI"
                    data={procedureHistoryFilterData({locations: props.locations.data})[4]}
                    onResetClick={(key) => {
                      handleResetClick(key);
                    }}
                    disabled={handleDisableFilter()}
                    setSelectedFilters={setSelectedFilters}
                    selectedFilters={selectedFilters}
                    appliedFilters={props.table.procedureHistory.filter}
                    selected={selectedFilters["PCTNo"]}
                  />

                <FilterSeparator />

                <MultipleSelect
                  disabled={handleDisableFilter()}
                  loading={false}
                  data={procedureHistoryFilterData()[0]}
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  data-cy="TYPE-MULTI"
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.procedureHistory.filter}
                  selected={selectedFilters["type"]}
                />

                <FilterSeparator />

                <MultipleSelect
                  loading={props.procedures.loading}
                  data-cy="PROCEDURE-NAME-MULTI"
                  data={
                    procedureHistoryFilterData({
                      proceduresName:
                        isValidObject(props.procedures?.data) &&
                        Object.values(props.procedures.data)?.map(
                          (data) => data.title
                        )
                    })[3]
                  }
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.procedureHistory.filter}
                  selected={selectedFilters["procedureName"]}
                />

                <FilterSeparator />

                <SingleSelect
                  disabled={handleDisableFilter()}
                  loading={props.procedures.loading}
                  data-cy="ASSIGNED-TO-SINGLE"
                  data={procedureHistoryFilterData()[2]}
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.procedureHistory.filter}
                  selected={selectedFilters["assignedTo"]}
                />
              </div>
            </div>

            {isFilterApplied(selectedFilters, "PROCEDURE_HISTORY")
              .validation && (
              <div
                style={{
                  width: "10%"
                }}
                className={`display-flex flex-justify-content-space-between`}
              >
                <div
                  style={{
                    width: "60%"
                  }}
                >
                  <Button
                    data-cy="FILTER-APPLY-BUTTON"
                    text="Apply"
                    boxShadow={false}
                    variant="filter"
                    loading={props.loading}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleApplyClick();
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "40%"
                  }}
                >
                  <Button
                    data-cy="FILTER-RESET-BUTTON"
                    variant="transparent"
                    text="Clear"
                    boxShadow={false}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleClearClick();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            height: `calc(100% - ${height + 32}px`
          }}
        >
          {/* {!collapse && (
            <>
              <div className="display-flex flex-justify-content-space-between margin-top-larger">
                {InfoCardData.map((data, index) => (
                  <div key={index} style={{ width: "calc(100% / 3 - 20px)" }}>
                    <InfoCard data={data} />
                  </div>
                ))}
              </div>
              <div className="display-flex flex-justify-content-space-between padding-top-larger ">
                <GraphCard
                  title="OPERATION LOCATIONS"
                  graph={<DoughnutChart data={sampleDoughnutChartData} />}
                  legend={
                    <div className="display-flex flex-justify-content-center padding-top-large">
                      {sampleDoughnutChartData.datasets[0].backgroundColor.map(
                        (data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={sampleDoughnutChartData}
                              color={data}
                              index={i}
                            />
                          </div>
                        )
                      )}
                    </div>
                  }
                />
                <GraphCard
                  title="OPERATION LOCATIONS"
                  graph={<DoughnutChart data={sampleDoughnutChartData} />}
                  legend={
                    <div className="display-flex flex-justify-content-center padding-top-large">
                      {sampleDoughnutChartData.datasets[0].backgroundColor.map(
                        (data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={sampleDoughnutChartData}
                              color={data}
                              index={i}
                            />
                          </div>
                        )
                      )}
                    </div>
                  }
                />
                <GraphCard
                  title="OPERATION LOCATIONS"
                  type="line"
                  graph={<LineChart data={sampleBarChartData} />}
                  legend={
                    <div
                      style={{
                        paddingTop: "31px"
                      }}
                    />
                  }
                />
              </div>
            </>
          )} */}

          {height && (
            <div
              style={{
                height: `calc(100% - ${collapse ? 0 : 420}px`
              }}
              className="padding-top-larger"
            >
              <Table
                title="ALL PROCEDURE HISTORY"
                setCollapse={(data) => {
                  setCollapse(data);
                  if (tableContainerRef.current) {
                    tableContainerRef.current.scrollTop = 0;
                  }
                }}
                allowCollapse={false}
                collapse={collapse}
                headers={procedureHistoryTableHeadings}
                onClick={(data) => {
                  props.setSelectedTableData("PROCEDURE_HISTORY", data);
                  props.navigate(
                    `locations/procedureHistory/${data.documentId}`
                  );
                }}
                data={
                  isValidObject(props.procedureHistory.data)
                    ? convertProcedureHistoryToTableData(
                        Object.values(props.procedureHistory.data)
                      ).slice(0, collapse ? 50 : 10)
                    : []
                }
                getField={procedureHistoryTableField}
                totalPage={Math.ceil(props.procedureHistory?.total / 50)}
                currentPage={currentPage}
                previousPageOnClick={() => {
                  props.getProcedureHistoryPreviousPage();
                }}
                nextPageOnClick={() => {
                  props.getProcedureHistoryNextPage();
                }}
                resetAllClick={() => {
                  handleClearClick();
                }}
                sort={props.table.procedureHistory.sort}
                handleSort={(title) => {
                  const isSameTitle =
                    props.table?.procedureHistory?.sort?.title === title;
                  props.setTableSort("PROCEDURE_HISTORY", {
                    title: title,
                    ascending: isSameTitle
                      ? !props.table?.procedureHistory?.sort?.ascending
                      : true
                  });
                }}
                backgroundColor="background-color-primary"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = function(state) {
  return {
    procedures: state.procedures,
    procedureHistory: state.procedureHistory,
    locations: state.locations,
    table: state.table,
    workforce: state.workforce
  };
};

const mapDispatchToProps = function() {
  return {
    setSelectedTableData: (tableName, data) =>
      setSelectedTableData(tableName, data),
    setTableFilter: (tableName, data) => setTableFilter(tableName, data),
    setTableSort: (tableName, data) => setTableSort(tableName, data),
    setTableSearchKey: (tableName, value) => setTableSearchKey(tableName, value)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProcedureHistory);
